import { render, staticRenderFns } from "./Coco.vue?vue&type=template&id=7d01b0b7&scoped=true&"
import script from "./Coco.vue?vue&type=script&lang=js&"
export * from "./Coco.vue?vue&type=script&lang=js&"
import style0 from "./Coco.vue?vue&type=style&index=0&id=7d01b0b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d01b0b7",
  null
  
)

export default component.exports